import { RQ } from 'utils';
import { addClickAnalytics, addRouteAnalytics } from 'utils/analytics';

export default {
  async init () {
    // console.log('============路由变化了============');
    const { materialId, materialTitle } = this.$route.query;
    this.pageTitle = materialTitle;
    await this.getVideoDetail({materialId});
    this.hotCommentList = await this.getHotCommentList({materialId});
    this.commentData = await this.getCommentList({page: 1, pageSize: 3, materialId});
    this.recommendList = await this.getRecommendList(1);
  },
  /**
   * 获取视频详情
   * @params
   *  materialId
   * @return code -3 素材下架
   **/
  async getVideoDetail (params) {
    let res = await RQ.mall.get('/api/h5/material/getMaterialDetail', {
      ...params
    }, {
      enterprise: '',
      loading: false
    });
    if (res && (res.code === -3 || !res.data)) {
      this.videoData = {
        ...res,
        data: {}
      }
    } else {
      this.videoData = res;
      const {commentNum, isLiked, likeNum} = res.data;
      this.commentNum = commentNum;
      this.isLiked = isLiked;
      this.likeNum = likeNum;
    }
    console.log('-----------getVideoDetail res', res)
    return res;
  },
  /**
   * 获取热评列表（无分页）
   * @params materialId
   * @returns {Promise.<*>}
   */
  async getHotCommentList (params) {
    const res = await RQ.mall.get('/api/h5/material/getHotCommentList', { ...params }, {enterprise: '', loading: false});
    return res;
  },
  /**
   * 获取评论列表
   * @params
   * {
   *   materialId
   * }
   **/
  async getCommentList (params) {
    const res = await RQ.mall.get('/api/h5/material/getCommentList', {
      pageSize: 20,
      ...params
    }, {
      enterprise: '',
      loading: false
    });
    console.log('-----------getCommentList', params, res);
    return res;
  },
  /**
   * 获取推荐列表
   * @params
   * {
   *   excludeMaterialId(当前视频materialId), page, pageSize, enterpriseNo, materialType(1图文，2视频), businessType(商家类型)
   * }
   **/
  async getRecommendList (page) {
    const {materialId, businessType} = this.$route.query;
    const res = await RQ.mall.get('/api/h5/material/getMaterialList', {
      page,
      pageSize: 200,
      excludeMaterialId: materialId,
      enterpriseNo: G.member.enterprise,
      materialType: 2,
      businessType
    }, {
      enterprise: '',
      loading: false
    });
    console.log('-----------getRecommendList', res);
    if (res && res.code === 0) {
      const { pageData, total, page } = res.data;
      if (page === 1) {
        this.finished = pageData.length === total;
        return res;
      } else {
        const oldPageData = this.recommendList.data.pageData;
        const mergePageData = oldPageData.concat(pageData);
        const data = Object.assign({}, res.data, {pageData: mergePageData});
        this.finished = oldPageData.length + pageData.length >= total;
        return Object.assign({}, res, {data});
      }
    }
    return res;
  },
  onChangedList (data) {
    console.log('---------------onChangedList', data)
    this.list = data;
  },
  /**
   * 点赞操作
   * 调用接口时，likeType字段、likeUser字段与isLiked字段是必须传递的，
   * 这样后端才知道点赞类型和是否点赞。如果是文章点赞，只需要materialId。
   * 如果是评论点赞，需要materialId和materialCommentId。
   * params: likeType,likeUser,materialId,materialCommentId,isLiked
   **/
  async handleLikeArticle (params) {
    let res = await RQ.mall.post('/api/h5/material/likeArticle', {
      ...params
    }, {jsonBody: false, enterprise: '', loading: false});
    if (res && res.code == 0) {
      console.log(res);
    }
  },
  /**
   * 跳转商品详情
   **/
  handleToGoods (item) {
    const {goodsId, specialId, groupGiftId} = item;
    if (this.__canceling__ !== true) {
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_wxapp` });
        wx.miniProgram.navigateTo({url: `/pages/goods/index?goodsId=${goodsId}&groupGiftId=${groupGiftId}&original=wxapp`});
      } else if (window.ReactNativeBridge) {
        // app
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'Goods',
          params: {
            goodsId, groupGiftId, original: 'app'
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_app` });
      } else {
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_h5` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
        // const queryStr = `?goodsId=${goodsId}&specialId=${specialId}&groupGiftId=${groupGiftId}`;
        // this.submitFn(queryStr);
      }
      console.log('-----------this.env', this.env);
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  /**
   * 跳转视频页
   **/
  handleToVideo (item = {}) {
    console.log('============handleToVideo', item);
    this.$router.push({
      path: `/wp/app/video/${item.materialId}`,
      query: {
        materialId: item.materialId,
        materialTitle: item.materialTitle
      }
    });
  },
  /**
   * 跳转评论页
   **/
  handleToCommentList (item = {}) {
    const { materialId } = this.$route.query;
    this.$router.push({
      path: `/wp/app/commentList/${materialId}`,
      query: {
        materialId,
        ...item
      }
    });
  },
  /**
   * 跳转分享页
   **/
  handleShare () {
    const { materialId, materialType, videoImg, materialTitle, materialContent } = this.$route.query;
    if (this.__canceling__ !== true) {
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        addClickAnalytics({ LogTitle: `浏览视频_${materialId}_wxapp` });
        wx.miniProgram.getEnv((res) => {
          console.log('------res', res);
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/module/other/pages/sharePoster/index?original=wxapp&materialId=${materialId}&materialTitle=${materialTitle}&materialType=${materialType}&shareImg=${videoImg}&materialContent=${materialContent}`,
              success: function (res) {
                console.log('success', res)
              },
              fail: function (res) {
                console.log('fail', res);
              },
              complete: function (res) {
                console.log('complete', res);
              }
            });
          }
        });
      } else if (window.ReactNativeBridge) {
        // app
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'ArticleShare',
          params: {
            materialId, materialType, original: 'app'
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        addClickAnalytics({ LogTitle: `浏览视频_${materialId}_app` });
      } else {
        addClickAnalytics({ LogTitle: `浏览视频_${materialId}_h5` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
        // const queryStr = `?goodsId=${goodsId}&specialId=${specialId}&groupGiftId=${groupGiftId}`;
        // this.submitFn(queryStr);
      }
      console.log('-----------this.env', this.env);
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  handlePlayVideo() {
    console.log('---------handlePlayVideo')
  },
  handlePauseVideo() {
    console.log('---------handlePauseVideo')
  },
  handleFocus() {
    console.log('-------handleFocus', this, window, this.$refs.content.scrollTop);
    this.onInput = true;
  },
  handleBlur() {
    console.log('-------handleBlur', this)
    let self = this;
    self.onInput = false;
  },
  loaded(e) {
    console.log('--------loaded', e);
    this.videoError = false;
  },
  handleLoadVideoError(e) {
    console.log('--------handleLoadVideoError', e);
    this.videoError = true;
  },
  handleScroll(e) {
    // console.log('--------handleScroll', e, this)
  },
  handleSendComment() {
    console.log('===========发表评论');
  },
  /**
   * 素材操作（点赞）
   **/
  handleToOperation() {
    const { materialId } = this.$route.query;
    const isLiked = this.isLiked;
    isLiked ? this.likeNum-- : this.likeNum++;
    this.isLiked = isLiked ? 0 : 1;
    this.handleLikeArticle({
      materialId: materialId,
      materialCommentId: null,
      likeType: 1,
      isLiked: isLiked ? 0 : 1
    });
  },
  handleToLike(e, commentId) {
    console.log('---------handleToLike', e, commentId);
    let iconEle = e.srcElement;
    // console.log(iconEle.style.display);
    const { materialId } = this.$route.query;
    let likeType = commentId ? 2 : 1;
    if (iconEle.classList.contains("icon-icon-heart-d-")) {
      // iconEle.classList.remove("icon-icon-heart-d-", "icon-red");
      // iconEle.classList.add("icon-icon-heart-");
      iconEle.previousElementSibling.style.display = 'block';
      iconEle.style.display = 'none';
      iconEle.nextElementSibling.innerText--;
      this.handleLikeArticle({
        materialId: materialId,
        materialCommentId: commentId || null,
        likeType: likeType,
        isLiked: 0
      });
    } else {
      // iconEle.classList.remove("icon-icon-heart-");
      // iconEle.classList.add("icon-icon-heart-d-", "icon-red");
      iconEle.style.display = 'none';
      iconEle.nextElementSibling.style.display = 'block';
      iconEle.nextElementSibling.nextElementSibling.innerText++;
      this.handleLikeArticle({
        materialId: materialId,
        materialCommentId: commentId || null,
        likeType: likeType,
        isLiked: 1
      });
    }
  },
  handleToReply() {
    console.log('---------handleToReply')
  },
  handleToLookMore() {
    console.log('---------handleToLookMore')
  },
  handleReply () {
    console.log('---------handleReply')
  },
  reloadVideo () {
    console.log('重新加载');
    const { materialId } = this.$route.query;
    this.getVideoDetail({materialId});
  }
}



// WEBPACK FOOTER //
// ./src/module/app/video/action.js